import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Api from "../../Api/Api";
import { username } from "../../API";
import "./Trending.css"; // Ensure the correct CSS file is imported

const LatestHome = () => {
  const [latest, setLatest] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getLatest();
      setLatest(data);
      console.log(data)
    };
    getData();
  }, [username]);
  const generateSlug = (title, id) => {
    return `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${id}`;
  };
  return (
    <div className="trending-home">
      {latest?.length !== 0 && (
        <>
          <h5 style={{
            color: "black",
            fontWeight: 600,
            marginBottom: "1rem",
            fontSize: "1.5rem"
          }}>Latest</h5>

          {/* Cards Slider */}
          <div className="trending-grid">
            {latest?.map((movie, index) => (
              <Link to={`/view/${generateSlug(movie?.title, movie._id)}`} className="movie-link" key={index}>
                <div className="movie-card">
                  <img
                    src={`${movie.thumbnail}`}
                    alt={`${movie.title}`}
                    className="movie-thumbnail"
                  />
                  <div className="movie-info">
                    <span className="movie-title">{movie.title}</span>
                    {/* <span className="movie-languages">
                      <small>
                        ({movie.Languages.slice(0, 15) || "English"}
                        {movie.Languages.length > 15 && `...`})
                      </small>
                    </span> */}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LatestHome;
